import React, { useEffect, useState } from "react";
import { NavLink, useLocation, useNavigate } from "react-router-dom";
import { scrollToElement, scrollToTop } from "./scrollHelpers";

const logo = `${process.env.PUBLIC_URL}/logo-nav.png?v=5`;

function Navbar() {
  const { pathname } = useLocation();
  const navigate = useNavigate();
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isAdminSignedIn, setIsAdminSignedIn] = useState(
    Boolean(localStorage.getItem("adminToken")),
  );
  const isLandingPage = pathname === "/";

  useEffect(() => {
    setIsMenuOpen(false);
  }, [pathname]);

  useEffect(() => {
    const updateAdminStatus = () => {
      setIsAdminSignedIn(Boolean(localStorage.getItem("adminToken")));
    };

    window.addEventListener("storage", updateAdminStatus);
    window.addEventListener("admin-auth-changed", updateAdminStatus);

    return () => {
      window.removeEventListener("storage", updateAdminStatus);
      window.removeEventListener("admin-auth-changed", updateAdminStatus);
    };
  }, []);

  const closeMenu = () => setIsMenuOpen(false);
  const afterRoutePaint = (callback) => {
    window.requestAnimationFrame(() => {
      window.requestAnimationFrame(callback);
    });
  };

  const handlePageNavigation = (event, path) => {
    event.preventDefault();
    closeMenu();

    if (pathname !== path) {
      navigate(path);
      afterRoutePaint(scrollToTop);
      return;
    }

    scrollToTop();
  };

  const handleCarsNavigation = (event) => {
    event.preventDefault();
    closeMenu();

    const scrollToCars = () => {
      const carsSection = document.getElementById("cars-section");
      scrollToElement(carsSection);
    };

    if (pathname !== "/") {
      navigate("/");
      afterRoutePaint(scrollToCars);
      return;
    }

    scrollToCars();
  };

  return (
    <div
      className={`navContainer ${isLandingPage ? "heroNav" : ""} ${
        isMenuOpen ? "mobileMenuOpen" : ""
      }`}
    >
      <nav className="navbar">
        <NavLink
          to="/"
          className="navLinkLogo"
          onClick={(event) => handlePageNavigation(event, "/")}
          end
        >
          <img
            src={logo}
            alt="Oh My Car logo"
            width="220"
            height="147"
            fetchPriority="high"
            decoding="async"
          />
        </NavLink>
        <button
          className="mobileMenuToggle"
          type="button"
          aria-label={isMenuOpen ? "Close navigation menu" : "Open navigation menu"}
          aria-expanded={isMenuOpen}
          onClick={() => setIsMenuOpen((open) => !open)}
        >
          <span />
          <span />
          <span />
        </button>
        <div className="navLinks">
          <NavLink
            to="/"
            className="navLink"
            onClick={(event) => handlePageNavigation(event, "/")}
            end
          >
            HOME
          </NavLink>
          <a href="/#cars-section" className="navLink" onClick={handleCarsNavigation}>
            CARS
          </a>
          <NavLink
            to="/about"
            className="navLink"
            onClick={(event) => handlePageNavigation(event, "/about")}
          >
            ABOUT US
          </NavLink>
          <NavLink
            to="/contact"
            className="navLink"
            onClick={(event) => handlePageNavigation(event, "/contact")}
          >
            CONTACT
          </NavLink>
          {isAdminSignedIn && (
            <NavLink
              to="/admin"
              className="navLink"
              onClick={(event) => handlePageNavigation(event, "/admin")}
            >
              ADMIN
            </NavLink>
          )}
        </div>
        <a className="navPhone" href="tel:+971529497677">
          <span aria-hidden="true">TEL</span>
          +971 52 949 7677
        </a>
      </nav>
    </div>
  );
}

export default Navbar;
